import { frontendURL } from '../../../helper/URLHelper';
import BulkCampaignsPage from './pages/BulkCampaignsPage.vue';
import BulkCampaignCreateForm from './pages/BulkCampaignCreateForm.vue';
import BulkCampaignImportWizard from './pages/BulkCampaignImportWizard.vue';
import BulkCampaignShowPage from './pages/BulkCampaignShowPage.vue';

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: 'bulk_campaigns',
};

const bulkCampaignsRoutes = [
  {
    path: frontendURL('accounts/:accountId/bulk_campaigns'),
    component: BulkCampaignsPage,
    meta,
    name: 'bulk_campaigns_main',
  },
  {
    path: frontendURL('accounts/:accountId/bulk_campaigns/new'),
    component: BulkCampaignCreateForm,
    meta,
    name: 'bulk_campaigns_new',
  },
  {
    path: frontendURL('accounts/:accountId/bulk_campaigns/import'),
    component: BulkCampaignImportWizard,
    meta,
    name: 'bulk_campaigns_import',
  },
  {
    path: frontendURL('accounts/:accountId/bulk_campaigns/:id'),
    component: BulkCampaignShowPage,
    meta,
    name: 'bulk_campaigns_show',
  },
];

export default {
  routes: bulkCampaignsRoutes,
};
